import { Col } from "antd";
import { onlyNumericRegex, aadhaarPattern, passportRegex, licenseRegex, rationCardRegex, panRegex, emailRegex, voterIdRegex, newInfoMobileRegex } from "../../utils/regex-patterns";
import { Notification } from "../../components/notification/notification";

export const renderSubHeading = (field: any) => {
    return (
        <Col span={24}>
            <p className="subHeading text-base my-2 font-semibold">
                {field.displayName}
            </p>
        </Col>
    )
}


export const splitArray = (arr: any, separator: any) => {
    return arr.reduce(function (acc: any, curr: any) {
      if (curr.fieldType === separator) {
        acc.push([]);
        acc[acc.length - 1].push(curr)
      } else {
        acc[acc.length - 1].push(curr);
      }
      return acc;
    }, [[]]);
  };



  export const validationMethod = (data:any) => {

            if (data.infoTypeId === 1 && !aadhaarPattern.test(data.newValue)) {
              Notification("error", "Invalid Aadhar");
              return true;
            } else if (data.infoTypeId === 2 && !voterIdRegex.test(data.newValue)) {
              Notification("error", "Invalid Voter Id");
              return true;
            } else if (
              data.infoTypeId === 3 &&
              !passportRegex.test(data.newValue)
            ) {
              Notification("error", "Invalid Passport Number");
              return true;
            } else if (data.infoTypeId === 6 && !licenseRegex.test(data.newValue)) {
              Notification("error", "Invalid License");
              return true;
            } else if (
              data.infoTypeId === 7 &&
              !rationCardRegex.test(data.newValue)
            ) {
              Notification("error", "Invalid Ration Card");
              return true;
            } else if (data.infoTypeId === 8 && data.countryCode === '+91' && !newInfoMobileRegex.test(data.newValue)) {
              Notification("error", "Invalid Mobile");
              return true;
            } else if (data.infoTypeId === 8 && data.countryCode !== '+91' && !onlyNumericRegex.test(data.newValue)) {
              Notification("error", "Only digits are allowed in Mobile number.");
              return true;
            } else if (data.infoTypeId === 10 && !panRegex.test(data.newValue)) {
              Notification("error", "Invalid PAN");
              return true;
            } else if (data.infoTypeId === 11 && !emailRegex.test(data.newValue)) {
              Notification("error", "Invalid Email");
              return true;
            }

            return false;
          
  }